var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgK19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5230_24396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5569 28.626H15.892C15.5201 28.9917 15.1128 29.2971 14.6682 29.5444H16.5569C16.6712 29.5444 16.7647 29.4509 16.7647 29.3366V28.8338C16.7647 28.7195 16.6712 28.626 16.5569 28.626Z",
    fill: "url(#paint0_radial_5230_24396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4528 28.626H17.9179C17.8036 28.626 17.7101 28.7195 17.7101 28.8338V29.3366C17.7101 29.4509 17.8036 29.5444 17.9179 29.5444H20.4528C20.5671 29.5444 20.6606 29.4509 20.6606 29.3366V28.8338C20.6606 28.7195 20.5671 28.626 20.4528 28.626Z",
    fill: "url(#paint1_radial_5230_24396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3488 28.626H21.8138C21.6996 28.626 21.606 28.7195 21.606 28.8338V29.3366C21.606 29.4509 21.6996 29.5444 21.8138 29.5444H24.3488C24.4631 29.5444 24.5566 29.4509 24.5566 29.3366V28.8338C24.5566 28.7195 24.4631 28.626 24.3488 28.626Z",
    fill: "url(#paint2_radial_5230_24396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2447 28.626H25.7098C25.5955 28.626 25.502 28.7195 25.502 28.8338V29.3366C25.502 29.4509 25.5955 29.5444 25.7098 29.5444H28.2447C28.359 29.5444 28.4525 29.4509 28.4525 29.3366V28.8338C28.4525 28.7195 28.359 28.626 28.2447 28.626Z",
    fill: "url(#paint3_radial_5230_24396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5694 26.4631C17.9429 23.7952 18.3688 23.0908 18.9194 22.6918L17.6997 21.4722L10.0305 29.1414C9.97441 29.1975 9.99934 29.2931 10.0741 29.3139C10.3567 29.3949 10.9801 29.5445 11.7572 29.5445C12.3764 29.5445 13.0932 29.4489 13.8142 29.1518C14.1321 29.0209 14.4521 28.8485 14.7638 28.6282C15.4245 28.1565 16.052 27.4667 16.5694 26.4631Z",
    fill: "url(#paint4_radial_5230_24396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7287 10.7818C28.5105 10.5636 28.2259 10.4556 27.9412 10.4556C27.6566 10.4556 27.3719 10.5636 27.1558 10.7818L17.8409 20.0967C17.708 20.2296 17.708 20.4457 17.8409 20.5787L18.4103 21.148L19.3619 20.1964L22.0818 17.4765L24.2843 15.274C24.2988 15.2595 24.3113 15.247 24.3258 15.2366C24.3279 15.2345 24.332 15.2325 24.3341 15.2304C24.3403 15.2241 24.3486 15.22 24.357 15.2138C24.5834 15.0517 24.8972 15.0725 25.1008 15.274L25.1819 15.3551C25.3606 15.5337 25.3979 15.8039 25.292 16.02C25.265 16.074 25.2276 16.1259 25.1819 16.1716L22.2459 19.1055L20.2075 21.1439L19.3079 22.0436L19.8772 22.6129C19.9436 22.6794 20.0309 22.7126 20.1182 22.7126C20.2055 22.7126 20.2927 22.6794 20.3592 22.6129L29.6741 13.298C30.1084 12.8637 30.1084 12.1594 29.6741 11.7251L28.7287 10.7818Z",
    fill: "url(#paint5_radial_5230_24396)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5230_24396",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8868 29.8125) rotate(-90) scale(1.4133 9.63052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5230_24396",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4251 29.8125) rotate(-90) scale(1.4133 13.5534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5230_24396",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.321 29.8125) rotate(-90) scale(1.4133 13.5534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5230_24396",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.217 29.8125) rotate(-90) scale(1.4133 13.5534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5230_24396",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1844 31.9017) rotate(-90) scale(12.4224 40.9724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5230_24396",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8665 26.2917) rotate(-90) scale(18.8621 56.3108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5230_24396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK19);
export default __webpack_public_path__ + "static/media/K19.cbccda11f182adfeaa4d1a846d28da41.svg";
export { ForwardRef as ReactComponent };